import {
  TOAST_TYPE_ERROR,
  TOAST_TYPE_INFO,
  TOAST_TYPE_SUCCESS,
  TOAST_TYPE_WARN,
} from '..'

export const SHOW_TOAST = 'SHOW_TOAST'
export const HIDE_TOAST = 'HIDE_TOAST'

export const showErrorToast = (message, props = { autoClose: false }) => ({
  type: SHOW_TOAST,
  payload: { message, toastType: TOAST_TYPE_ERROR, props },
})

export const showInfoToast = (message, props = { autoClose: 5000 }) => ({
  type: SHOW_TOAST,
  payload: { message, toastType: TOAST_TYPE_INFO, props },
})

export const showSuccessToast = (message, props = { autoClose: 5000 }) => ({
  type: SHOW_TOAST,
  payload: { message, toastType: TOAST_TYPE_SUCCESS, props },
})

export const showWarnToast = (message, props = { autoClose: 5000 }) => ({
  type: SHOW_TOAST,
  payload: { message, toastType: TOAST_TYPE_WARN, props },
})

export const hideToast = (toastId) => ({
  type: HIDE_TOAST,
  payload: { toastId },
})
